<script>
  import { Form, isDev } from '$client';
  export let data;
  if (isDev() && !data)
    data = {
      header: 'Заказать вывоз',
      description: 'Перезвоним в течение 5-и минут !',
      button: 'Отправить заявку',
      fields: [
        {
          id: 1,
          __component: 'fields.tekst',
          placeholder: 'Ваше имя',
          pattern: '^[а-яА-Я ].{4,100}$',
          type: 'small',
          required: true,
          key: 'name',
        },
        {
          id: 2,
          __component: 'fields.telefon',
          required: true,
          description: null,
          key: 'phone',
        },

        {
          id: 2,
          __component: 'fields.pochta',
          placeholder: 'Электронная почта',
          description: null,
          required: false,
          key: 'email',
        },
      ],
    };
</script>

<section class="container main-form" id="form">
  <img
    loading="lazy"
    height="344"
    width="510"
    src="https://admin.uberi.pro/uploads/Image_TV_fd5648d89e.webp"
    alt="Вывоз ненужных вещей" />
  <Form {data} />
</section>

<style lang="scss">
  section {
    position: relative;
    display: inline-flex;
    gap: 40px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-block: 100px;

    @media only screen and (max-width: 1499.98px) {
      padding-block: 80px;
    }

    @media only screen and (max-width: 1199.98px) {
      // flex-direction: column;

      img {
        width: 450px;
        height: auto;
      }
    }

    @media only screen and (max-width: 991.98px) {
      img {
        width: 350px;
      }
    }

    @media only screen and (max-width: 767.98px) {
      flex-direction: column;
      gap: 80px;
      padding-block: 30px;

      img {
        width: 350px;
      }
    }

    @media only screen and (max-width: 575.98px) {
      img {
        width: 300px;
      }
    }
  }

  section::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 50%;
    height: 100%;
    background: #22eaac;
    background-color: #22eaac;
    background-image: url('https://admin.uberi.pro/uploads/logo_pattern_3a0caf4660_7fa5749925.svg');
    background-repeat: repeat;
    background-position: center center;
    background-size: 150%;
    content: '';
    clip-path: polygon(0 0, 79% 0, 91% 100%, 0% 100%);

    @media only screen and (max-width: 1767.98px) {
      background-size: 200%;
      clip-path: polygon(0 0, 70% 0, 85% 100%, 0% 100%);
    }

    @media only screen and (max-width: 1199.98px) {
      width: 100%;
      clip-path: polygon(0 0, 32% 0, 47% 100%, 0% 100%);
    }

    @media only screen and (max-width: 991.98px) {
      clip-path: polygon(0 0, 32% 0, 47% 100%, 0% 100%);
    }

    @media only screen and (max-width: 767.98px) {
      height: 300px;
      background-size: 160%;
      clip-path: none;
    }

    @media only screen and (max-width: 575.98px) {
      height: 250px;
      background-size: 220%;
    }
  }

  .main-form {
    :global(form) {
      width: calc(45%);

      @media only screen and (max-width: 767.98px) {
        width: 100%;
      }
    }

    :global(form > p) {
      margin-bottom: 30px;
      color: rgb(44 51 60 / 85%);
      font-size: 18px;
      font-family: Roboto;
    }

    :global(form > div) {
      flex-direction: column;
      gap: 15px;
    }

    :global(> form > h2) {
      margin-bottom: 16px;
      font-weight: 800;
      font-family: Vela Sans;
    }

    :global(> form > button) {
      padding: 18px 40px;
      background: #22eaac;
      border-radius: 5px;
    }
  }
</style>
